var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "nineLucky-wrapper"
  }, [_c("div", {
    staticClass: "main-wrapper"
  }, _vm._l(_vm.nineList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "item-wrapper text-center",
      class: {
        active: _vm.option.index == item.index
      }
    }, [item.imgUrl ? _c("img", {
      class: index == 4 ? "chart-wrapper" : "baseImg",
      attrs: {
        src: item.imgUrl,
        alt: ""
      },
      on: {
        click: function ($event) {
          return _vm.startDraw(index);
        }
      }
    }) : _vm._e(), item.title ? _c("p", [_vm._v(_vm._s(_vm.$t(item.title)))]) : _vm._e()]);
  }), 0)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };